module.exports = __webpack_public_path__ + "img/Sul.4c29385c.png";